module.exports = __webpack_public_path__ + "img/signUpSuccessfully.536c2a26.png";